import React from "react";
import cn from "classnames";
import { snakeCase } from "lodash";
import { Paper, Box, Table, TableHead, TableBody, TableRow, TableCell } from "@mui/material";
import I18n from "utils/i18n.js";
import BooleanText from "components/admin_v2/common/BooleanText";
import useCommonPageStyles from "components/admin_v2/common/useCommonPageStyles";
import { useTableFormStyles } from "components/admin_v2/common/useTableFormStyles";
import { formatPhone } from "lib/util";

const VendorAssociations = ({ vendor }) => {
  const cls = useCommonPageStyles();
  const clsTableForm = useTableFormStyles();

  if (!vendor) return;

  const associations = {
    addresses: [
      { column: "Address", value: (a) => a.address },
      { column: "Name", value: (a) => a.name },
      { column: "Primary Address", value: (a) => <BooleanText val={a.primary} /> },
      { column: "Lat", value: (a) => a.lat },
      { column: "Lng", value: (a) => a.lng }
    ],
    phoneNumbers: [
      { column: "Name", value: (p) => p.name },
      { column: "Number", value: (p) => formatPhone(p.number) },
      { column: "Line Type", value: (p) => p.lineType },
      {
        column: "Opt-Out communication",
        value: (p) => <BooleanText val={p.optOutCommunication} />
      },
      { column: "Primary Phone", value: (p) => <BooleanText val={p.primary} /> },
      { column: "Language", value: (p) => p.language }
    ]
  };

  return Object.entries(associations).map(([itemsName, columns]) => (
    <Box my={5} key={itemsName}>
      <Paper className={cls.paper}>
        <Box className={cls.subTitle}>
          {I18n.t(`vendor_config.vendor.title.${snakeCase(itemsName)}`)}
        </Box>
        <Table aria-label="table" className={cn(`vendor-${itemsName}`, cls.table)}>
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell
                  className={clsTableForm.tableHeader}
                  key={`${itemsName}-header-${col.column}`}
                >
                  {col.column}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {vendor[itemsName]?.map((item) => (
              <TableRow hover tabIndex={-1} key={`${itemsName}-row-${item.id}`}>
                {columns.map((col) => (
                  <TableCell className={clsTableForm.cell} key={`${itemsName}-cell-${col.column}`}>
                    {col.value(item)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  ));
};

export default VendorAssociations;
